import { render, staticRenderFns } from "./Movements.vue?vue&type=template&id=6cc946b5&scoped=true&"
import script from "./Movements.vue?vue&type=script&lang=js&"
export * from "./Movements.vue?vue&type=script&lang=js&"
import style0 from "./Movements.vue?vue&type=style&index=0&id=6cc946b5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc946b5",
  null
  
)

export default component.exports